import { mergeWith, isArray, union } from "lodash";

import { UPDATE_ENTITIES, REPLACE, CLEAR_ENTITY } from "./Actions";

import type { Action } from "./Actions";
import type { Reducer } from "redux";

export type EntityTable<T> = Record<string, T>;
export const entitiesReducer =
  <T>(emptyTable: T): Reducer<T, Action<T>> =>
  (entities: T = emptyTable, action: Action<T>): T => {
    switch (action.type) {
      case UPDATE_ENTITIES: {
        const newEntities: any = action.payload.entities;
        const oldEntities: any = entities;
        const merged = mergeWith({}, oldEntities, newEntities, (objValue, srcValue) => {
          if (isArray(objValue) && isArray(srcValue)) {
            // union by identity (IDs)
            return union(objValue, srcValue);
          }
          return undefined; // fall back to default merge
        });
        return merged as any;
      }

      case REPLACE: {
        return { ...entities, ...action.payload.entities };
      }

      case CLEAR_ENTITY: {
        const newEntities = { ...entities };
        newEntities[action.payload.collection] = {};
        return newEntities;
      }

      default:
        return entities;
    }
  };
